import { FormControl, FormGroup } from '@angular/forms';
import { Nillable } from '@web/utils';

export type AdminRefundSettingsFormControls = {
  isCodEmailSent: FormControl<boolean | null>;
  codMessageEmails: FormControl<Nillable<string>>;
};

export class AdminRefundSettingsFormData {
  public static CodMessageEmailMaxLength = 255;

  public constructor(
    private readonly data: {
      isCodEmailSent: boolean;
      codMessageEmails: string[];
    },
  ) {}

  public get isCodEmailSent(): boolean {
    return this.data.isCodEmailSent;
  }

  public get codMessageEmails(): string[] {
    return this.data.codMessageEmails;
  }
}

/* prettier-ignore */
export type AdminRefundSettingsFormGroup = FormGroup<AdminRefundSettingsFormControls>;
